import React, { useState, useEffect, Fragment } from "react";
import { Formik, Form, Field } from "formik";
import axios from "axios";
import toast from "react-hot-toast";
import addbutton from "../static/images/add-button.png";
import $ from "jquery";

const GaleriaFotos = ({ data, reload, edit }) => {
  const [empty, setEmpty] = useState(true);
  const [selectPhoto, setselectPhoto] = useState("");
  const [showImg, setshowImg] = useState("");
  const [FieldValue, setFieldValue] = useState("");

  useEffect(() => {
    setEmpty(data?.length == 0);
  }, [data]);

  function FindPhoto(id) {
    setselectPhoto(data.find((i) => i.companyVideoId === id));
    setFieldValue(data.find((i) => i.companyVideoId === id).image);
  }

  function DeletePhoto() {
    let config = {
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios
      .post("company-video/delete/" + selectPhoto.companyVideoId, config)
      .then((result) => {
        if (result.status === 200) {
          toast.success(result.data.message, {
            duration: 4000,
          });
          $("#eliminar-foto-modal").modal("hide");
          reload();
        }
      })
      .catch(function (error) {
        $("#eliminar-foto-modal").modal("hide");
      });
  }

  function ActualizarFoto(values) {
    const img = getImage();
    // const input = document.getElementById("imageUpdate");

    let formData = new FormData();
    formData.append("image", img);
    formData.append("companyId", selectPhoto.companyId);
    formData.append("companyVideoId", selectPhoto.companyVideoId);
    formData.append("description", values.description);

    let config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
    };

    axios
      .post("company-video/update-image", formData, config)
      .then((result) => {
        if (result.status === 200) {
          toast.success("Foto cargada exitosamente", {
            duration: 6000,
          });
          $("#actualizar-foto-modal").modal("hide");
          reload();
        }
      })
      .catch(function (error) {
        $("#actualizar-foto-modal").modal("hide");
      });
  }

  const base64toBlob = (base64Data) => {
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      var begin = sliceIndex * sliceSize;
      var end = Math.min(begin + sliceSize, bytesLength);

      var bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    return new Blob(byteArrays, { type: "image/jpg" });
  };

  const getImage = () => {
    const input = document.getElementById("imageUpdate");

    const img = input.files[0];
    if (img !== undefined) {
      return img;
    } else {
      return base64toBlob(FieldValue);
    }
  };

  return (
    <Fragment>
      {empty ? (
        <label className="login-label">
          Todavía no ha cargado ninguna foto.
        </label>
      ) : (
        <div className="col-12">
          <div className="row mt-3">
            {data.map((item, index) => {
              return (
                <div className="col-xs-12 col-md-4" key={index}>
                  <div className="col-xs-10 col-md-10 mb-10">
                    <img
                      src={item.image}
                      style={{ height: "200px", width: "100%" }}
                    ></img>
                    <span>{item.description}</span>
                  </div>
                  {edit ? (
                    <div className="col-2">
                      <div className="toolset" style={{ width: "100px" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <a
                            href="#"
                            className="edit-button"
                            data-bs-toggle="modal"
                            data-bs-target="#actualizar-foto-modal"
                            onClick={() => FindPhoto(item.companyVideoId)}
                          ></a>
                          <a
                            href="#"
                            className="delete-button"
                            data-bs-toggle="modal"
                            data-bs-target="#eliminar-foto-modal"
                            onClick={() => FindPhoto(item.companyVideoId)}
                          ></a>
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      <div
        id="eliminar-foto-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="form form--white">
                <div className="div__wrapper">
                  <div className="form__title text-center">Eliminar Foto</div>
                  <div className="form__row">
                    <div className="col-sm-12 ">
                      <label htmlFor="names">
                        Desea eliminar este registro?
                      </label>
                    </div>
                  </div>
                  <div className="form__row">
                    <button
                      className="btn btn--gradient btn__icon btn__icon--door"
                      onClick={() => DeletePhoto()}
                    >
                      Eliminar
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="actualizar-foto-modal"
        className="kr-modal modal fade"
        tabIndex="-1"
        role="dialog"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="modal-title"></div>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Formik
                enableReinitialize={true}
                initialValues={{
                  description: selectPhoto.description,
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  setSubmitting(true);
                  ActualizarFoto(values);
                  //   convert(values);
                  resetForm(true);
                  setSubmitting(false);
                }}
                //validationSchema={Validaciones}
              >
                {({ errors, touched, isSubmitting }) => (
                  <Form>
                    <div className="mb-4 row">
                      <label htmlFor="image" className="col-sm-2 pe-0">
                        Seleccione una imagen:
                      </label>
                      <div className="col-sm-10">
                        <input
                          id="imageUpdate"
                          name="imageUpdate"
                          type="file"
                          onChange={(event) => {
                            setFieldValue(event.currentTarget.files[0]);
                          }}
                        ></input>
                      </div>
                    </div>
                    <div className="mb-4 row">
                      <label htmlFor="description" className="col-sm-2 pe-0">
                        Descripción:
                      </label>
                      <div className="col-sm-10">
                        <Field
                          as="textarea"
                          id="description"
                          name="description"
                          //type="textarea"
                          required
                          className="form-control form-control-sm"
                        ></Field>
                        {errors.description && touched.description && (
                          <span className="form__validation form__validation--error">
                            {errors.description}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="modal-footer">
                      <button
                        type="button"
                        data-bs-dismiss="modal"
                        className="btn btn--cancel"
                      >
                        Cancelar
                      </button>
                      <button
                        disabled={isSubmitting}
                        type="submit"
                        className="btn btn--small btn--purple"
                      >
                        Subir
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default GaleriaFotos;
